import type { FaireProductEntity } from "../../entity_types/product";

export const p_wy7gy45sdy: FaireProductEntity = {
  token: "p_wy7gy45sdy",
  type: "product",
  name: "Dark And Twisted Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/cbefdd005fefc845c5ba3f7dc77c1bd72f5ec9f07f1aca1fdfa2ac488b5b0e86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79a293d9dc20a52940df29d7e6b4f82755cabeb268b1d7dca93a74d26d7f8c92.jpeg",
    "https://cdn.faire.com/fastly/f1ef6dc26df4d4e0d4c18632136cf2a8da5735435ef1f6fbce5bcbc17c739b05.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5a9225f17bd201ab22bfd47ddca7abf8d7c8d1054cda0e050378bfbead09e911.jpeg",
    "https://cdn.faire.com/fastly/cf5d45ba911b65d7233409d7d17b990dcc2e33581d6cdaf600a36d90a760f4cd.jpeg",
    "https://cdn.faire.com/fastly/3d92f85b8bf6b4d65fb06da15eb3769ffdfd4cff58dbe9cb33a103f272062ba8.jpeg",
    "https://cdn.faire.com/fastly/b352c6a51bcdbc76ffe4e2d0c5c578952fc2c02d2a6f874179718a929909a548.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for the villain in someone else’s story. 😈\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:24.019Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
